import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router, Routes, RouterModule } from '@angular/router';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {

  

  constructor(public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute, public http: HttpClient, private router: Router) { this.ping(), this.currency(), this.operator() }
  subID: string;
  viewMode = 'tab1';
  loaded:boolean = false;
  channel: any = [];
  siteInfo: any = [];
  siteID = environment.siteID;
  tag: any;
  myData: any;
  subChannel: boolean;
  subSite: boolean;
  bouquetUser: boolean;
  playlists: any = [];
  sliderOptions = { dots: false, navigation: true, nav: false, autoplay: false, loop: false, autoplayTimeout: 2000, autoplayHoverPause: true, lazyLoad: true, responsive: { 0: { items: 1 }, 600: { items: 2 }, 960: { items: 4 }, 1200: { items: 4 } } };
  contents: any;
  content: any;
  playlist: any;
  sitebillingAgent: any;
  siteRenew: any;
  channelbillingAgent: any;
  currencySign: any;
  subscriptionStatusId: any;
  subscribeData: any = [];
  profileData: any=[];
  profileID = '';

  public ping() {
    this.route.params.subscribe(params2 => {
      this.subID = params2['channelID'];
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      this.http.get('https://api-staging.videyo.tv/endpoint/getSubscriptionStatus?siteID='+this.siteID+'&subscriptionStatusId='+this.subID, {
        headers: myheader
      })
        .subscribe(
          data => {
            setTimeout(() => {
              /** spinner ends after 5 seconds */
              this.loaded = true;
            }, 1500);
            this.channel = data;
          },
          error => {
            
          }
        );
    });
  }
 
  unsubscribeSite() {
    var tempURL = 'https://staging.videyo.tv/billing/unsubscribe?id='+this.subID;
    
    this.http.get(tempURL, {}).subscribe(
      data => {
        setTimeout(()=>{    
          this.router.navigate(['/my-subscriptions']);
          document.getElementById('unsubmodal').click();
     }, 1500);
      },
      error => {
        


      }
    )
  }
  unsubscribeChannel() {
    var tempURL = 'https://staging.videyo.tv/billing/unsubscribe?id='+this.subID;
    this.http.get(tempURL, {}).subscribe(
      data => {
        setTimeout(()=>{    
          this.router.navigate(['/my-subscriptions']);
          document.getElementById('unsubmodal').click();
     }, 1500);
      },
      error => {


      }
    )
  }
  currencyType: any[];
  operatorType: any[];
  name: string = '';
  mobNum: string = '';
  email: string = '';
  password: string = '';
  currencyChoice: string = '';
  mobOperatorChoice: string = '';
  preferredCountries = ['za', 'us', 'au', 'ru', 'gb'];
  onMobNumKeyUp(event: any) {
    this.mobNum = event.target.value;
  }
  onNameKeyUp(event: any) {
    this.name = event.target.value;
  }
  onEmailKeyUp(event: any) {
    this.email = event.target.value;
  }
  onPasswordKeyUp(event: any) {
    this.password = event.target.value;
  }
  onCurrencyChoice(event: any) {
    this.currencyChoice = event.target.value;
  }
  onMobOperatorChoice(event: any) {
    this.mobOperatorChoice = event.target.value;
  }
  public currency() {
    this.http.get('https://api-staging.videyo.tv/manage/listCurrencies', {
    })
      .subscribe(
        data => {
          this.currencyType = data['currency'];
        },
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('myModal1', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
      );
  }
  public operator() {
    this.http.get('https://api-staging.videyo.tv/manage/listMobileOperators', {
    })
      .subscribe(
        data => {
          this.operatorType = data['mobileOperator'];
        },
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('myModal1', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
      );
  }
  public postProfile() {
    var tempURL = 'https://api-staging.videyo.tv/manage/register?phoneNumber=' + this.mobNum.replace('+', '') + '&password=' + this.password + '&name=' + this.name + '&email=' + encodeURIComponent(this.email) + '&currencyId=' + this.currencyChoice + '&mobileOperatorId=' + this.mobOperatorChoice;
    this.http.post(tempURL, {}).subscribe(
      data => {
       
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('myModal1', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
     
      }
    )

  }



  ngOnInit() {
  }

}

